const getTranslation = (field, language, fallback = 'fr') => {
  if (!field) return '';
  if (typeof field === 'string') {
    try {
      const parsed = JSON.parse(field);
      if (typeof parsed === 'object' && parsed !== null) {
        return parsed[language] || parsed[fallback] || '';
      }
    } catch (e) {}
    return field;
  }
  if (typeof field === 'object') {
    return field[language] || field[fallback] || '';
  }
  return '';
};

export default getTranslation;
